/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SubmitAnswerRequestDto model module.
 * @module model/SubmitAnswerRequestDto
 * @version v0
 */
class SubmitAnswerRequestDto {
    /**
     * Constructs a new <code>SubmitAnswerRequestDto</code>.
     * Answer submission data
     * @alias module:model/SubmitAnswerRequestDto
     * @param sessionId {Number} 
     * @param pageId {Number} 
     * @param questionId {Number} 
     * @param answerId {Number} 
     */
    constructor(sessionId, pageId, questionId, answerId) { 
        
        SubmitAnswerRequestDto.initialize(this, sessionId, pageId, questionId, answerId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, sessionId, pageId, questionId, answerId) { 
        obj['sessionId'] = sessionId;
        obj['pageId'] = pageId;
        obj['questionId'] = questionId;
        obj['answerId'] = answerId;
    }

    /**
     * Constructs a <code>SubmitAnswerRequestDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubmitAnswerRequestDto} obj Optional instance to populate.
     * @return {module:model/SubmitAnswerRequestDto} The populated <code>SubmitAnswerRequestDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubmitAnswerRequestDto();

            if (data.hasOwnProperty('sessionId')) {
                obj['sessionId'] = ApiClient.convertToType(data['sessionId'], 'Number');
            }
            if (data.hasOwnProperty('pageId')) {
                obj['pageId'] = ApiClient.convertToType(data['pageId'], 'Number');
            }
            if (data.hasOwnProperty('questionId')) {
                obj['questionId'] = ApiClient.convertToType(data['questionId'], 'Number');
            }
            if (data.hasOwnProperty('answerId')) {
                obj['answerId'] = ApiClient.convertToType(data['answerId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SubmitAnswerRequestDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SubmitAnswerRequestDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SubmitAnswerRequestDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

SubmitAnswerRequestDto.RequiredProperties = ["sessionId", "pageId", "questionId", "answerId"];

/**
 * @member {Number} sessionId
 */
SubmitAnswerRequestDto.prototype['sessionId'] = undefined;

/**
 * @member {Number} pageId
 */
SubmitAnswerRequestDto.prototype['pageId'] = undefined;

/**
 * @member {Number} questionId
 */
SubmitAnswerRequestDto.prototype['questionId'] = undefined;

/**
 * @member {Number} answerId
 */
SubmitAnswerRequestDto.prototype['answerId'] = undefined;






export default SubmitAnswerRequestDto;

